import "../index.css";

type PropsProductDescription = {
  description?: string;
  technicalDescription?: string;
  setOpenDetails: (value: boolean) => void;
  openDetails: boolean;
};

export function ProductDescription({
  description,
  technicalDescription,
  setOpenDetails,
  openDetails,
}: PropsProductDescription) {
  return (
    <>
      {description && (
        <div
          className="product-option"
          style={openDetails ? { backgroundColor: "#FFF" } : {}}
        >
          <div
            className="hide-item"
            onClick={() => setOpenDetails(!openDetails)}
          >
            <p>Detalhes</p>
          </div>
          <div className="details">
            <p
              style={openDetails ? {} : { WebkitLineClamp: 4 }}
              dangerouslySetInnerHTML={
                description ? { __html: description } : undefined
              }
            ></p>
          </div>
        </div>
      )}

      {technicalDescription && (
        <div
          className="product-option"
          style={openDetails ? { backgroundColor: "#FFF" } : {}}
        >
          <div
            className="hide-item"
            onClick={() => setOpenDetails(!openDetails)}
          >
            <p>Especificação Técnica</p>
          </div>
          <div className="details">
            <p
              style={openDetails ? {} : { WebkitLineClamp: 4 }}
              dangerouslySetInnerHTML={
                technicalDescription
                  ? { __html: technicalDescription }
                  : undefined
              }
            ></p>
          </div>
        </div>
      )}
    </>
  );
}
